<template>
  <customFieldsAddingPreview
    :icon='"date.svg"'
    :name="preloadedItem.name || 'Calendar'">

    <template :slot='"body"'>
      <div class="input-mb input-box d-flex flex-nowrap">
        <v-menu v-model="menu" :close-on-content-click="false" max-width="290">
            <template v-slot:activator="{ on }">
              <v-text-field
              prepend-icon="event"
              :value="computedDateFormattedMomentjs"
              :placeholder=preloadedItem.placeholder
              readonly
              v-on="on">
                <template v-slot:append-outer>
                  <span v-if="value" class="cursor-pointer" @click="clearDate()">
                    Clear
                  </span>
                </template>
              </v-text-field>
            </template>
            <v-date-picker v-model="value" @change="menu=false" />
          </v-menu>
      </div>
    </template>
  </customFieldsAddingPreview>
</template>

<script>
import moment from 'moment'
import customFieldsAddingPreview from '../customFieldsAddingPreview'
import { mapGetters } from 'vuex'
export default {
  props: {
    preloadedItem: {
      type: Object,
      default: () => {
        return {
          name: '',
          placeholder: '',
          defaultValue: null
        }
      }
    }
  },
  data: function() {
    return {
      menu: false,
      value: null
    }
  },
  components: {
    customFieldsAddingPreview
  },
  watch: {
    'preloadedItem.defaultValue': {
      handler (newDefaultValue, oldDefaultValue) {
        if (this.value === oldDefaultValue) {
          this.value = newDefaultValue
        }
      },
      deep: true
    }
  },
  created () {
    if (this.preloadedItem.defaultValue && this.preloadedItem.defaultValue !== null) {
      this.value = moment(this.preloadedItem.defaultValue).utc(true)
    }
  },
  computed: {
    ...mapGetters('user', ['getDateTimeFormat']),
    computedDateFormattedMomentjs() {
      return this.value && this.value !== null ? moment(this.value).utc(true).format('dddd, MMMM Do YYYY') : ''
    }
  },
  methods: {
    clearDate() {
      this.value = null
    }
  }
}
</script>

<style lang="scss" module src="../commonStyles/index.module.scss"></style>
